module.exports = __webpack_public_path__ + "img/title5.05df940c.svg";